import { componentQrl, inlinedQrl, _jsxBranch, useStore, useComputedQrl, useLexicalScope, _jsxC, Fragment, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import { Fragment as Fragment$1 } from "@builder.io/qwik/jsx-runtime";
import { SDKS_SUPPORTING_PERSONALIZATION, getInitPersonalizationVariantsFnsScriptString } from "../../blocks/personalization-container/helpers.qwik.mjs";
import { TARGET } from "../../constants/target.qwik.mjs";
import { handleABTestingSync } from "../../helpers/ab-tests.qwik.mjs";
import { getDefaultCanTrack } from "../../helpers/canTrack.qwik.mjs";
import { ContentComponent } from "../content/content.qwik.mjs";
import { InlinedScript } from "../inlined-script.qwik.mjs";
import { InlinedStyles } from "../inlined-styles.qwik.mjs";
import { checkShouldRenderVariants, getUpdateCookieAndStylesScript, getVariants, getInitVariantsFnsScriptString } from "./helpers.qwik.mjs";
const ContentVariants = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  _jsxBranch();
  const state = useStore({
    shouldRenderVariants: checkShouldRenderVariants({
      canTrack: getDefaultCanTrack(props.canTrack),
      content: props.content
    })
  });
  const updateCookieAndStylesScriptStr = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    var _a;
    const [props2] = useLexicalScope();
    return getUpdateCookieAndStylesScript(getVariants(props2.content).map((value) => ({
      id: value.testVariationId,
      testRatio: value.testRatio
    })), ((_a = props2.content) == null ? void 0 : _a.id) || "");
  }, "ContentVariants_component_updateCookieAndStylesScriptStr_useComputed_FtJXWpnoDYg", [
    props
  ]));
  const hideVariantsStyleString = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    return getVariants(props2.content).map((value) => `.variant-${value.testVariationId} { display: none; } `).join("");
  }, "ContentVariants_component_hideVariantsStyleString_useComputed_fQIC0fJqAl4", [
    props
  ]));
  const defaultContent = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    var _a;
    const [props2, state2] = useLexicalScope();
    return state2.shouldRenderVariants ? {
      ...props2.content,
      testVariationId: (_a = props2.content) == null ? void 0 : _a.id
    } : handleABTestingSync({
      item: props2.content,
      canTrack: getDefaultCanTrack(props2.canTrack)
    });
  }, "ContentVariants_component_defaultContent_useComputed_00q2HQsQPYc", [
    props,
    state
  ]));
  return /* @__PURE__ */ _jsxC(Fragment, {
    children: [
      !props.isNestedRender && TARGET !== "reactNative" ? /* @__PURE__ */ _jsxC(Fragment$1, {
        children: [
          /* @__PURE__ */ _jsxC(InlinedScript, {
            id: "builderio-init-variants-fns",
            get scriptStr() {
              return getInitVariantsFnsScriptString();
            },
            get nonce() {
              return props.nonce || "";
            },
            [_IMMUTABLE]: {
              id: _IMMUTABLE,
              nonce: _fnSignal((p0) => p0.nonce || "", [
                props
              ], 'p0.nonce||""'),
              scriptStr: _IMMUTABLE
            }
          }, 3, "XM_0"),
          SDKS_SUPPORTING_PERSONALIZATION.includes(TARGET) ? /* @__PURE__ */ _jsxC(InlinedScript, {
            id: "builderio-init-personalization-variants-fns",
            get nonce() {
              return props.nonce || "";
            },
            get scriptStr() {
              return getInitPersonalizationVariantsFnsScriptString();
            },
            [_IMMUTABLE]: {
              id: _IMMUTABLE,
              nonce: _fnSignal((p0) => p0.nonce || "", [
                props
              ], 'p0.nonce||""'),
              scriptStr: _IMMUTABLE
            }
          }, 3, "XM_1") : null
        ]
      }, 1, "XM_2") : null,
      state.shouldRenderVariants ? /* @__PURE__ */ _jsxC(Fragment$1, {
        children: [
          /* @__PURE__ */ _jsxC(InlinedStyles, {
            id: "builderio-variants",
            get styles() {
              return hideVariantsStyleString.value;
            },
            get nonce() {
              return props.nonce || "";
            },
            [_IMMUTABLE]: {
              id: _IMMUTABLE,
              nonce: _fnSignal((p0) => p0.nonce || "", [
                props
              ], 'p0.nonce||""'),
              styles: _fnSignal((p0) => p0.value, [
                hideVariantsStyleString
              ], "p0.value")
            }
          }, 3, "XM_3"),
          /* @__PURE__ */ _jsxC(InlinedScript, {
            id: "builderio-variants-visibility",
            get scriptStr() {
              return updateCookieAndStylesScriptStr.value;
            },
            get nonce() {
              return props.nonce || "";
            },
            [_IMMUTABLE]: {
              id: _IMMUTABLE,
              nonce: _fnSignal((p0) => p0.nonce || "", [
                props
              ], 'p0.nonce||""'),
              scriptStr: _fnSignal((p0) => p0.value, [
                updateCookieAndStylesScriptStr
              ], "p0.value")
            }
          }, 3, "XM_4"),
          (getVariants(props.content) || []).map((variant) => {
            return /* @__PURE__ */ _jsxC(ContentComponent, {
              get apiHost() {
                return props.apiHost;
              },
              get isNestedRender() {
                return props.isNestedRender;
              },
              get nonce() {
                return props.nonce;
              },
              content: variant,
              showContent: false,
              get model() {
                return props.model;
              },
              get data() {
                return props.data;
              },
              get context() {
                return props.context;
              },
              get apiKey() {
                return props.apiKey;
              },
              get apiVersion() {
                return props.apiVersion;
              },
              get customComponents() {
                return props.customComponents;
              },
              get linkComponent() {
                return props.linkComponent;
              },
              get canTrack() {
                return props.canTrack;
              },
              get locale() {
                return props.locale;
              },
              get enrich() {
                return props.enrich;
              },
              get isSsrAbTest() {
                return state.shouldRenderVariants;
              },
              get blocksWrapper() {
                return props.blocksWrapper;
              },
              get blocksWrapperProps() {
                return props.blocksWrapperProps;
              },
              get contentWrapper() {
                return props.contentWrapper;
              },
              get contentWrapperProps() {
                return props.contentWrapperProps;
              },
              get trustedHosts() {
                return props.trustedHosts;
              },
              [_IMMUTABLE]: {
                apiHost: _fnSignal((p0) => p0.apiHost, [
                  props
                ], "p0.apiHost"),
                apiKey: _fnSignal((p0) => p0.apiKey, [
                  props
                ], "p0.apiKey"),
                apiVersion: _fnSignal((p0) => p0.apiVersion, [
                  props
                ], "p0.apiVersion"),
                blocksWrapper: _fnSignal((p0) => p0.blocksWrapper, [
                  props
                ], "p0.blocksWrapper"),
                blocksWrapperProps: _fnSignal((p0) => p0.blocksWrapperProps, [
                  props
                ], "p0.blocksWrapperProps"),
                canTrack: _fnSignal((p0) => p0.canTrack, [
                  props
                ], "p0.canTrack"),
                contentWrapper: _fnSignal((p0) => p0.contentWrapper, [
                  props
                ], "p0.contentWrapper"),
                contentWrapperProps: _fnSignal((p0) => p0.contentWrapperProps, [
                  props
                ], "p0.contentWrapperProps"),
                context: _fnSignal((p0) => p0.context, [
                  props
                ], "p0.context"),
                customComponents: _fnSignal((p0) => p0.customComponents, [
                  props
                ], "p0.customComponents"),
                data: _fnSignal((p0) => p0.data, [
                  props
                ], "p0.data"),
                enrich: _fnSignal((p0) => p0.enrich, [
                  props
                ], "p0.enrich"),
                isNestedRender: _fnSignal((p0) => p0.isNestedRender, [
                  props
                ], "p0.isNestedRender"),
                isSsrAbTest: _fnSignal((p0) => p0.shouldRenderVariants, [
                  state
                ], "p0.shouldRenderVariants"),
                linkComponent: _fnSignal((p0) => p0.linkComponent, [
                  props
                ], "p0.linkComponent"),
                locale: _fnSignal((p0) => p0.locale, [
                  props
                ], "p0.locale"),
                model: _fnSignal((p0) => p0.model, [
                  props
                ], "p0.model"),
                nonce: _fnSignal((p0) => p0.nonce, [
                  props
                ], "p0.nonce"),
                showContent: _IMMUTABLE,
                trustedHosts: _fnSignal((p0) => p0.trustedHosts, [
                  props
                ], "p0.trustedHosts")
              }
            }, 3, variant.testVariationId);
          })
        ]
      }, 1, "XM_5") : null,
      /* @__PURE__ */ _jsxC(ContentComponent, {
        get apiHost() {
          return props.apiHost;
        },
        get nonce() {
          return props.nonce;
        },
        get isNestedRender() {
          return props.isNestedRender;
        },
        get content() {
          return defaultContent.value;
        },
        showContent: true,
        get model() {
          return props.model;
        },
        get data() {
          return props.data;
        },
        get context() {
          return props.context;
        },
        get apiKey() {
          return props.apiKey;
        },
        get apiVersion() {
          return props.apiVersion;
        },
        get customComponents() {
          return props.customComponents;
        },
        get linkComponent() {
          return props.linkComponent;
        },
        get canTrack() {
          return props.canTrack;
        },
        get locale() {
          return props.locale;
        },
        get enrich() {
          return props.enrich;
        },
        get isSsrAbTest() {
          return state.shouldRenderVariants;
        },
        get blocksWrapper() {
          return props.blocksWrapper;
        },
        get blocksWrapperProps() {
          return props.blocksWrapperProps;
        },
        get contentWrapper() {
          return props.contentWrapper;
        },
        get contentWrapperProps() {
          return props.contentWrapperProps;
        },
        get trustedHosts() {
          return props.trustedHosts;
        },
        [_IMMUTABLE]: {
          apiHost: _fnSignal((p0) => p0.apiHost, [
            props
          ], "p0.apiHost"),
          apiKey: _fnSignal((p0) => p0.apiKey, [
            props
          ], "p0.apiKey"),
          apiVersion: _fnSignal((p0) => p0.apiVersion, [
            props
          ], "p0.apiVersion"),
          blocksWrapper: _fnSignal((p0) => p0.blocksWrapper, [
            props
          ], "p0.blocksWrapper"),
          blocksWrapperProps: _fnSignal((p0) => p0.blocksWrapperProps, [
            props
          ], "p0.blocksWrapperProps"),
          canTrack: _fnSignal((p0) => p0.canTrack, [
            props
          ], "p0.canTrack"),
          content: _fnSignal((p0) => p0.value, [
            defaultContent
          ], "p0.value"),
          contentWrapper: _fnSignal((p0) => p0.contentWrapper, [
            props
          ], "p0.contentWrapper"),
          contentWrapperProps: _fnSignal((p0) => p0.contentWrapperProps, [
            props
          ], "p0.contentWrapperProps"),
          context: _fnSignal((p0) => p0.context, [
            props
          ], "p0.context"),
          customComponents: _fnSignal((p0) => p0.customComponents, [
            props
          ], "p0.customComponents"),
          data: _fnSignal((p0) => p0.data, [
            props
          ], "p0.data"),
          enrich: _fnSignal((p0) => p0.enrich, [
            props
          ], "p0.enrich"),
          isNestedRender: _fnSignal((p0) => p0.isNestedRender, [
            props
          ], "p0.isNestedRender"),
          isSsrAbTest: _fnSignal((p0) => p0.shouldRenderVariants, [
            state
          ], "p0.shouldRenderVariants"),
          linkComponent: _fnSignal((p0) => p0.linkComponent, [
            props
          ], "p0.linkComponent"),
          locale: _fnSignal((p0) => p0.locale, [
            props
          ], "p0.locale"),
          model: _fnSignal((p0) => p0.model, [
            props
          ], "p0.model"),
          nonce: _fnSignal((p0) => p0.nonce, [
            props
          ], "p0.nonce"),
          showContent: _IMMUTABLE,
          trustedHosts: _fnSignal((p0) => p0.trustedHosts, [
            props
          ], "p0.trustedHosts")
        }
      }, 3, "XM_6")
    ]
  }, 1, "XM_7");
}, "ContentVariants_component_4tFRiQMMEfM"));
export {
  ContentVariants,
  ContentVariants as default
};
